const links = [
  { label: "Experience", href: "#/experience", match: "/experience" },
  { label: "Projects", href: "#/projects", match: "/projects" },
  { label: "Blog", href: "#/blog", match: "/blog" },
];

// Clicking a link whose hash is already in the URL doesn't fire hashchange,
// so scroll to the section ourselves (e.g. pressing Experience twice).
function scrollIfCurrent(e, href) {
  if (window.location.hash !== href) return;
  e.preventDefault();
  const section = document.getElementById(href.replace("#/", ""));
  if (section) section.scrollIntoView({ behavior: "smooth" });
  else window.scrollTo({ top: 0, behavior: "smooth" });
}

export default function Navbar({ path }) {
  return (
    <header className="sticky top-0 z-50 bg-bg/90 backdrop-blur border-b border-line">
      <nav className="container-narrow h-16 flex items-center justify-between">
        <a
          href="#/"
          onClick={(e) => scrollIfCurrent(e, "#/")}
          className="font-medium hover:text-muted transition-colors"
        >
          James Yu
        </a>
        <div className="flex items-center gap-6 text-sm">
          {links.map((l) => {
            const active = path.startsWith(l.match);
            return (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => scrollIfCurrent(e, l.href)}
                className={`transition-colors ${
                  active ? "text-fg" : "text-muted hover:text-fg"
                }`}
              >
                {l.label}
              </a>
            );
          })}
        </div>
      </nav>
    </header>
  );
}
